// AgreementsProgressViewController.tsx
import React, { useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Creators as requestStatusActions } from '@/domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as agreementInfoActions } from '@/domain/useCases/scholarshipsDiscounts/getAgreementInfo/actions';
import routes from '@/presentation/components/Routes/routingMap';
import AgreementsProgressView from './AgreementsProgressView';
import constants from '@/presentation/modules/procedures/constants';

const AgreementsProgressViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { isLoading: isLoadingInfo, data: agreementInfo } = useSelector(
    (state: any) => state.getAgreementInfo
  );
  const { requestId } = useSelector((state: any) => state.registerAgreement);
  const {
    procedure,
    request,
    isLoading: isLoadingDetail
  } = useSelector((state: any) => state.procedureStudentStatus);

  useEffect(() => {
    if (!isLoadingDetail && !procedure) {
      history.push('/tramites');
    }
  }, [isLoadingDetail, history, procedure]);

  useEffect(() => {
    if (requestId) {
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          constants.categories.requests.procedures.scholarshipsDiscounts,
          requestId
        )
      );
    }
  }, []);

  useEffect(() => {
    if (!agreementInfo) {
      dispatch(
        agreementInfoActions.getAgreementInfo(
          constants.categories.requests.procedures.scholarshipsDiscounts
        )
      );
    }
  }, [agreementInfo, dispatch]);
  const documentsList = useMemo(() => {
    const beneficiaryId = procedure?.detail?.certificateDetail
      ?.beneficiaryId as string | number;
    if (beneficiaryId == null) return [];
    const mapping: Record<string, string[]> = {
      '1': [
        'DNI del colaborador.',
        'Última boleta de pago de haberes del colaborador.'
      ],
      '2': [
        'DNI del colaborador.',
        'DNI del cónyuge (alumno).',
        'Acta de matrimonio o declaración jurada simple de convivencia.',
        'Última boleta de pago de haberes del colaborador.'
      ],
      '3': [
        'DNI del colaborador.',
        'DNI del hijo (alumno).',
        'Partida de nacimiento del hijo (alumno).',
        'Última boleta de pago de haberes del colaborador.'
      ]
    };
    return mapping[`${beneficiaryId}`] ?? [];
  }, [procedure]);

  const handleBack = useCallback(() => {
    const state = location.state as
      | { from?: string; hadInProgressRequest?: boolean }
      | undefined;

    if (state?.from === 'info' && state?.hadInProgressRequest === true) {
      history.push(routes.student.procedures.listScholarshipsDiscounts);
    } else {
      history.goBack();
    }
  }, [history, location]);

  const handleReviewInPayments = useCallback(() => {
    history.push(routes.student.payments.home);
  }, [history]);

  const requirementsAuto = useMemo(() => {
    if (!agreementInfo?.validations) return [];
    return agreementInfo.validations.map((v: any) => ({
      text: v.message,
      valid: v.isValid
    }));
  }, [agreementInfo]);

  return (
    <AgreementsProgressView
      handleBack={handleBack}
      procedure={procedure}
      request={request}
      isLoading={isLoadingDetail || isLoadingInfo}
      requirementsAuto={requirementsAuto}
      documentsList={documentsList}
      handleReviewInPayments={handleReviewInPayments}
    />
  );
};

export default AgreementsProgressViewController;
